// extracted by mini-css-extract-plugin
export default {"contenedor":"CampoBuscarEquipo_contenedor__02eap","boton":"CampoBuscarEquipo_boton__AEpZb"};